import { render } from "./ConfirmLeave.vue?vue&type=template&id=490cbc02"
import script from "./ConfirmLeave.vue?vue&type=script&lang=js"
export * from "./ConfirmLeave.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__